/**
 * Retrieves the article detail from template tags
 * 
 * Example usage:
 * <a data-gtm-article">
 *      link Text
 *      <template gtm-article-detail='title'>Article Title</template>
 *      <template gtm-article-detail='author'>Article Author</template>
 *      <template gtm-article-detail='publishDate'>Artiche Publish Date</template>
 *      <template gtm-article-detail='tags'>TAG | TAG | TAG</template>
 * </a>
 * 
 * getCardTitle(document.querySelector("[data-gtm-section='card']")) => "Title heading"
 */
export default function getArticleDetail({ target }) {
    const title = target.querySelector("[gtm-article-detail='title']")?.content?.textContent;
    const author = target.querySelector("[gtm-article-detail='author']")?.content?.textContent;
    const publishDate = target.querySelector("[gtm-article-detail='publishDate']")?.content?.textContent;
    const tags = target.querySelector("[gtm-article-detail='tags']")?.content?.textContent;
    return { title, author, publishDate, tags };
};
